<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row">
            <div class="offset-xl-2 col-xl-8 offset-md-0 col-md-12">
                <div class="card" :class="[isRegistered ? 'registered' : '']">
                    <div class="card-body">
                        <h4 class="card-title">Rejestracja</h4>
                        <form-wizard
                            :color="theme.primaryColor"
                            nextButtonText="Dalej"
                            backButtonText="Wstecz"
                            finishButtonText="Zakończ"
                            @on-complete="handleComplete"
                            ref="formWizard"
                        >
                            <tab-content
                                v-for="(content, section, index) of cfg"
                                :key="keyPrefix + section"
                                :icon="content.icon"
                                :title="content.name"
                                :before-change="() => validateStep(index)"
                            >
                                <div class="row d-flex justify-content-center">
                                    <div v-if="content.canSkip" class="col-md-12 text-center text-warning mb-3">
                                      <i class="fa fa-exclamation-triangle"></i> Wybranie tych grup nie jest wymagane. Jeśli nie chcesz wybierać żadnej grupy, klinkij `Dalej`.
                                    </div>
                                    <div class="col-xl-6 col-md-12">
                                        <select-server-groups :ref="'select-' + index" :groups="content.groups" :limit="1"/>
                                    </div>
                                    <!-- end col -->
                                </div>
                                <!-- end row -->
                            </tab-content>
                        </form-wizard>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->
            </div>
        </div>
    </Layout>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import RegistrationService from "@/services/registration.service";
import {
    notificationMethods
} from "@/state/helpers";

/**
 * Starter component
 */
export default {
    name: "Registration",
    components: {
        Layout,
        PageHeader,
        FormWizard,
        TabContent
    },
    data() {
        return {
            title: "Proces rejestracji",
            items: [
                {
                    text: "Konto",
                    href: "/"
                },
                {
                    text: "Proces rejestracji",
                    active: true
                }
            ],
            loading: true,
            cfg: {},
            chosenGroups: {},
            keyPrefix: "1"
        };
    },
    computed: {
        isRegistered() {
            return this.$store.getters['auth/user'].isRegistered;
        },
        theme() {
            return this.$store.getters['cfg/get'].global.theme;
        },
    },
    watch: {
        isRegistered() {
            this.loadData();
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...notificationMethods,
        getStartIndex() {
            return this.isRegistered ? (Object.keys(this.cfg)).length-1 : 0;
        },
        changeTab(toIndex) {
            if (toIndex == 0) {
                this.$refs.formWizard.changeTab(0, toIndex);
                return;
            }

            for (let i = 0; i <= toIndex; i++)
                this.$refs.formWizard.changeTab(i == 0 ? 0 : i-1, i);
        },
        loadData() {
            this.loading = true;

            RegistrationService.getData().then(
                response => {
                    this.cfg = response.data;
                    this.keyPrefix++;
                    setTimeout(() => this.changeTab(this.getStartIndex()), 100);
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        getCfgByIndex(index) {
          return this.cfg[Object.keys(this.cfg)[index]];
        },
        validateStep(index) {
            const results = this.$refs['select-'+index][0].getSelected();
            this.chosenGroups[index] = results.length === 1 ? results[0].sgid : null;
            const result = (results.length === 1 || this.getCfgByIndex(index).canSkip);
            if (!result)
                this.error('Musisz zaznaczyć przynajmniej jedną grupę!');
            return result;
        },
        handleComplete() {
            this.loading = true;

            RegistrationService.register(this.chosenGroups).then(
                () => {
                    this.$store.dispatch('auth/refreshClientInfo', true).then(() => {
                        this.success("Zarejestrowano pomyślnie!");
                        this.loading = false;
                    });
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        }
    }
};
</script>

<style>
    .stepTitle:not(.active) {
        color: #a6b0cf;
    }

    .registered:before {
        content: '';
        position: absolute;
        width: 100%;
        top: 0;
        height: 100%;
        left: 0;
        background: rgba(60,60,60,.5);
        z-index: 100;
    }

    .registered:after {
        content: "Zarejestrowano";
        position: absolute;
        width: 100%;
        top: 44%;
        height: 16%;
        left: 0;
        background-color: #34c38f;
        z-index: 101;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 1.5em;
    }
</style>